var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"bar","height":"350","options":_vm.apexChatData.barChart.chartOptions,"series":_vm.apexChatData.barChart.series}})}
var staticRenderFns = []

export { render, staticRenderFns }